/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockX = createReactComponent("clock-x", "IconClockX", [
  ["path", { d: "M20.926 13.15a9 9 0 1 0 -7.835 7.784", key: "svg-0" }],
  ["path", { d: "M12 7v5l2 2", key: "svg-1" }],
  ["path", { d: "M22 22l-5 -5", key: "svg-2" }],
  ["path", { d: "M17 22l5 -5", key: "svg-3" }]
]);

export { IconClockX as default };
//# sourceMappingURL=IconClockX.js.map
